var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultRevisionForm',{ref:"form",attrs:{"value":_vm.value,"resource":_vm.resource,"rules":_vm.validationRules}},[_c('div',{staticClass:"card-section"},[_c('ProductListUnitsTable',{attrs:{"value":_vm.value.units,"editable":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }